import { formatMetricValue, formatMetricValueCompact } from '@/lib/metric-format';

import type { CardSpec } from '../asistente.types';

interface KpiCardsProps {
  cards: CardSpec[];
}

/** Indicadores que el backend adjunta a una respuesta (tarjetas pequeñas). */
export function KpiCards({ cards }: KpiCardsProps) {
  const visibles = cards.filter((card) => card?.title);

  if (visibles.length === 0) return null;

  return (
    <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {visibles.map((card, index) => (
        <div
          key={`${card.title}-${index}`}
          className="rounded-xl border border-ink-100 bg-white p-3 shadow-soft"
        >
          <p className="text-[11px] font-medium text-ink-500">{card.title}</p>

          {card.value !== undefined ? (
            <p
              title={formatMetricValue(card.value, card.format)}
              className="mt-1 truncate font-mono text-base font-bold tracking-tight text-ink-900 tabular-nums"
            >
              {formatMetricValueCompact(card.value, card.format)}
            </p>
          ) : null}
        </div>
      ))}
    </div>
  );
}
